import { gql } from '@apollo/client'

export const SHARED_FACILITY_DATA = gql`
  fragment SharedFacilityData on Facility {
    facilitiesId
    facilitiesName
    facilitiesDescription
    facilitiesSecurityOnSite
    facilitiesSecurityCameras
    facilitiesSecurityOther
    facilitiesSecurity24Hrs
    facilitiesOnsiteRepair
    facilitiesRenewableEnergy
    facilitiesFeatured
    facilitiesPricePerKwh
    facilitiesSetupFees
    facilitiesImagesCsvPrioritized
    facilitiesVideosCsvPrioritized
    facilityAvailability
    countryName
    countryCode
  }
`
